export default __webpack_public_path__ + "static/img-project-13-da2a2e4ef6dc52b3de8b4aa269858d42.png";